import {
  removeOnboardingToken,
  removeSecureDocUploaderToken,
} from 'utils/tokens'
import { clearProspect } from 'actions/prospect'
import { goErrorPage } from 'actions/routing'
import { IDLE_SESSION_TIMEOUT_ERROR } from 'utils/errorTypes'
import {
  clearJointAccounts,
} from 'actions/jointAccount'
import {
  clearSidebarDataLoaded,
} from 'actions/sidebar'
import { setError } from 'actions/onboarding'
import store from 'store'

const RENEW_SESSION_TIMEOUT_MINUTES = 13
const EXPIRE_SESSION_TIMEOUT_MINUTES = 15

export const SessionFeatures = {
  ONBOARDING: 'onboarding',
  SECURE_DOC_UPLOADER: 'secure_doc_uploader'
}

class SessionHandler {

  constructor () {
    this.sessionEnabled = false
    this.sessionCheckedAt = null
    this.sessionTimeout = null
    this.logoutTimeout = null
  }

  initSession () {
    this.clearSessionTimers()
    this.handleSessionInit()
  }

  handleSessionInit () {
    this.sessionEnabled = true
    this.sessionCheckedAt = new Date().getTime()
    this.resetSessionTimeout()
  }

  resetSessionTimeout () {
    if (this.checkSleep()) {
      this.clearSessionTimers()
      if (this.sessionEnabled) {
        this.sessionTimeout = setTimeout(() => {
          this.askToRenewSession()
        }, 60000 * RENEW_SESSION_TIMEOUT_MINUTES)
      }
    } else {
      this.expireSession()
    }
  }

  clearSessionTimers () {
    clearTimeout(this.sessionTimeout)
    clearTimeout(this.logoutTimeout)
  }

  disableSession () {
    this.sessionEnabled = false
    this.clearSessionTimers()
  }

  expireSession () {
    this.sessionEnabled = false
    this.clearSessionTimers()
    removeOnboardingToken()
    removeSecureDocUploaderToken()
    store.dispatch(clearProspect())
    store.dispatch(clearJointAccounts())
    store.dispatch(clearSidebarDataLoaded())
    store.dispatch(setError(IDLE_SESSION_TIMEOUT_ERROR))
    store.dispatch(goErrorPage())
  }

  checkSleep () {
    // Make sure it's been less than 15 minutes since the last check (in case
    // device goes to sleep, JS gets delayed)
    const now = new Date().getTime()
    const diff = now - this.sessionCheckedAt

    return !(diff > (60000 * EXPIRE_SESSION_TIMEOUT_MINUTES))
  }

  askToRenewSession () {
    clearTimeout(this.logoutTimeout)
    this.logoutTimeout = setTimeout(() => {
      this.expireSession()
    }, 60000 * (EXPIRE_SESSION_TIMEOUT_MINUTES - RENEW_SESSION_TIMEOUT_MINUTES))
  }

  renewSession () {
    if (this.sessionEnabled) {
      clearTimeout(this.logoutTimeout)
      if (this.checkSleep()) {
        this.sessionCheckedAt = new Date().getTime()
        this.resetSessionTimeout()
      } else {
        this.expireSession()
      }
    }
  }

}

export default SessionHandler



// WEBPACK FOOTER //
// ./src/SessionHandler.js